/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

export const MAX_EVAL_JOBS_COUNT = 15;
export const ENUM_INDEX_COLORS = ['#6CF2A2', '#FFCB78', '#F26C74'];
export const FALLBACK_COLORS = ['#6CF2A2', '#FFCB78', '#F26C74', '#43B0CD', '#A78BFA'];

export const sizeStyles = {
  default: 'h-6 px-2 py-1 text-sm leading-[18px]',
  compact: 'h-5 px-3 text-[11px] text-[11px] leading-[16px]',
};

// EvalFeedback (thumbs up/down) hover bar: 2 buttons (14px icon + 4px padding each) + 8px container padding
export const EVAL_FEEDBACK_BAR_WIDTH = 44;

// Static floor for the badge container so even the shortest label leaves room for the
// feedback bar to sit beside it (not on top of it) once hover shifts the label to the left.
export const evalBadgeMinWidth = {
  default: 'min-w-24', // 96px
  compact: 'min-w-20', // 80px
};

export const labelColors = {
  // Primary
  positive: 'border-[#32580F] text-[#9CF526] bg-[#0000001F]',
  negative: 'border-[#7B2126] text-[#F9A8AD] bg-[#0000001F]',
  neutral: 'border-[#40565A] text-[#EBEFF1] bg-[#08242F]',
  // Aliases
  off_topic: 'border-[#7B2126] text-[#F9A8AD] bg-[#0000001F]', // same as negative
  frustrated: 'border-[#7B2126] text-[#F9A8AD] bg-[#0000001F]', // same as negative
  on_topic: 'border-[#32580F] text-[#9CF526] bg-[#0000001F]', // same as positive
  ok: 'border-[#32580F] text-[#9CF526] bg-[#0000001F]', // same as positive
};

export const MAX_DISPLAY_ENTRIES = 3;